import CustomModal from "../../../components/CustomModal";
import React, {useEffect, useState} from "react";
import LabeledSelect from "../../../components/selects/LabeledSelect";
import {useDispatch, useSelector} from "react-redux";
import {setVisibility, tryUpdateBundleTimerItem} from "../../../redux/slices/dynamicElementsSlice";

const BundleTimerSelector = ({ selected}) => {

  const [selectedItem, setSelectedItem] = useState();

  const {
    loading,
    focusItemList,
  } = useSelector((state) => state.focusItem);

  const {
    loading:editing,
    visible,
    type
  } = useSelector((state) => state.dynamicElements.editing);

  const dispatch = useDispatch();
  const _condition = visible && type === "edit";


  const _validTypes = focusItemList.filter((d) => d.display_type === "PRODUCT_VIEW" && d.type === "PRODUCT_CAMPAIGN");

  const onChange = (focus) => {
    setSelectedItem(focus);
  };

  const saveChanges = () => {
    if (selectedItem?.id)
      dispatch(tryUpdateBundleTimerItem({id: selectedItem.id}));
  };

  useEffect(() => {
    if (visible && selected) {
      setSelectedItem(selected);
    }

  }, [visible]);

  return (
    <CustomModal
      title="Set Timer Type"
      bodyClasses="max-w-md"
      showModal={_condition}
      setShowModal={() => dispatch(setVisibility({visible: false}))}
      loading={loading || editing}
      disabled={!selectedItem || selected?.id === selectedItem?.id}
      onClick={saveChanges}
      buttonLabel="Save Changes"
    >
      <LabeledSelect
        value={selectedItem}
        getOptionLabel={(option) => option.title}
        loading={loading}
        isDisabled={loading || editing}
        options={_validTypes}
        getOptionValue={(option) => option.id}
        onChange={onChange}
      />

    </CustomModal>
  );
};

export default BundleTimerSelector;

